<script lang="ts">
    import type { Res } from "@repo/backend/client";
    import type { ThreadId, TransactionId } from "@repo/backend/types";
    import CaseView from "../../lib/components/case-view.svelte";

    const {
        transaction,
    }: {
        transaction: Res["Get dashboard transactions v2"][number];
    } = $props();
</script>

<CaseView
    threadId={transaction.threadId as ThreadId}
    transactionId={transaction.suggestedTransactionId as TransactionId}
    diffMode={true}
/>
